"use client";

import { useState, useEffect } from "react";

import { DEVICE_BREAKPOINTS } from "@/globals";

export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState<
        | {
              breakpoint: DEVICE_BREAKPOINTS;
              height: number;
              width: number;
          }
        | undefined
    >();

    useEffect(() => {
        // Handler to call on window resize
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
                breakpoint:
                    window.innerWidth > Number(DEVICE_BREAKPOINTS.xl)
                        ? DEVICE_BREAKPOINTS.xl
                        : window.innerWidth > Number(DEVICE_BREAKPOINTS.lg)
                          ? DEVICE_BREAKPOINTS.lg
                          : window.innerWidth > Number(DEVICE_BREAKPOINTS.md)
                            ? DEVICE_BREAKPOINTS.md
                            : window.innerWidth > Number(DEVICE_BREAKPOINTS.sm)
                              ? DEVICE_BREAKPOINTS.sm
                              : window.innerWidth > Number(DEVICE_BREAKPOINTS.xs)
                                ? DEVICE_BREAKPOINTS.xs
                                : DEVICE_BREAKPOINTS.min,
            });
        };

        // Initial size set and add event listener
        if (typeof window !== "undefined") {
            handleResize();
            window.addEventListener("resize", handleResize);
        }

        // Cleanup event listener on unmount
        return () => {
            if (typeof window !== "undefined") {
                window.removeEventListener("resize", handleResize);
            }
        };
    }, []);

    return windowSize;
};
